module.exports = __webpack_public_path__ + "img/15-2.304271f6.jpg";